import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  GiftCategory,
  GiftCategoryRequest,
  GiftCategoryResponse,
} from './types'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const giftCategoriesListMounted = createEvent<GiftCategoryRequest>()

export const getGiftsCategories = fx<GiftCategoryRequest, GiftCategoryResponse>(
  {
    method: 'GET',
    url: `/giftshop/gift_category`,
  },
)

export const $giftsCategories = restore<GiftCategory[]>(
  getGiftsCategories.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfGiftsCategories = restore(
  getGiftsCategories.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: giftCategoriesListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    // if (filters) {
    //   //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
    //   let newObj = Object.keys(filters).reduce((accumulator, key) => {
    //     if (filters[key as keyof typeof filters] != null) {
    //       accumulator[key as keyof typeof filters] =
    //         key === 'country'
    //           ? filters[key as keyof typeof filters]
    //           : `${filters[key as keyof typeof filters]}`
    //     }
    //
    //     return accumulator
    //   }, {} as any)
    //
    //   if (!isAllElementsOfSearchTextNotExist(searchText)) {
    //     newObj = { ...newObj, ...mapSearchText(searchText) }
    //   }
    //
    //   if (Object.keys(newObj).length) {
    //     // @ts-ignore
    //     query['where'] = `${JSON.stringify(newObj)}`
    //   }
    // }

    return {
      query,
    }
  },
  target: getGiftsCategories,
})
